import { RESET_SELECT_JOURNAL, SELECT_JOURNAL_BY_MATCH, SET_MATCHES_BY_TOURNAMENTS } from "../constants/matches";

const initialState = {
    matchesByTournament:[],
    loading:false,
    selectedJournal: '',
}

function matches (state = initialState, action){
    switch (action.type) {
        case SET_MATCHES_BY_TOURNAMENTS:
            return {...state, matchesByTournament: action.payload};
        case SELECT_JOURNAL_BY_MATCH:
            return {...state, selectedJournal: action.payload};
        case RESET_SELECT_JOURNAL:
            return {...state, selectedJournal: ''}
    
        default:
            return state;
    }

}

export default matches